"use client";

import { useRouter } from "next/navigation";
import { useTranslate } from "@/utils/languageTranslation";

export default function InternalBoardButton({ language }: { language: string }) {
  const { t } = useTranslate();
  const router = useRouter();

  const handleButtonClick = () => {
    // Check if user is already authenticated
    const token = localStorage.getItem("strapiToken");
    const user = localStorage.getItem("strapiUser");
    
    if (token && user) {
      try {
        JSON.parse(user); // Validate user data
        router.push("/internal-board");
      } catch (error) {
        // Clear invalid data and redirect to auth
        localStorage.removeItem("strapiToken");
        localStorage.removeItem("strapiUser");
        router.push("/internal-board/auth");
      }
    } else {
      router.push("/internal-board/auth");
    }
  };

  return (
    <button
      onClick={handleButtonClick}
      className="  px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors font-medium text-xs lg:text-sm"
    >
      {t("internal_boards") || "Internal Board"}
    </button>
  );
}
